import Colcade from 'colcade';
import UiHelper from './UiHelper';

const selectors = {
    wrap: '.js-masonry-gallery',
    galleryColumns: '.js-masonry-gallery__columns',
    galleryItem: '.js-masonry-gallery__item'
}

class ColcadeMasonryFactory
{
    static init()
    {
        Array.from(UiHelper.getNodes(selectors.wrap)).forEach(wrap =>
        {
            new ColcadeMasonry(wrap);
        });
    }
}
export default ColcadeMasonryFactory;

class ColcadeMasonry
{
    constructor(wrap)
    {
        // selector string as first argument
        var colc = new Colcade( wrap, {
            columns: selectors.galleryColumns,
            items: selectors.galleryItem
        });
    }
}